export const getDay = (day) => {
  switch (day) {
    case 0:
      return 'Sunday';
    case 1:
      return 'Monday';
    case 2:
      return 'Tuesday';
    case 3:
      return 'Wednesday';
    case 4:
      return 'Thursday';
    case 5:
      return 'Friday';
    case 6:
      return 'Saturday';
    default:
      return 'Sunday';
  }
};

export const getMonth = (month) => {
  switch (month) {
    case 0:
      return 'Jan';
    case 1:
      return 'Feb';
    case 2:
      return 'Mar';
    case 3:
      return 'Apr';
    case 4:
      return 'May';
    case 5:
      return 'Jun';
    case 6:
      return 'Jul';
    case 7:
      return 'Aug';
    case 8:
      return 'Sep';
    case 9:
      return 'Oct';
    case 10:
      return 'Nov';
    case 11:
      return 'Dec';
    default:
      return 'Jan';
  }
};

export const getTwoDigitDate = (date) => {
  const twoDigitDate = date.getUTCDate() < 10 ? `0${date.getUTCDate()}` : date.getUTCDate();
  return twoDigitDate;
};

export const getTwoDigitDateNonUTC = (date) => {
  const twoDigitDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return twoDigitDate;
};

export const getTwoDigitMonth = (date) => {
  const twoDigitMonth = date.getUTCMonth() + 1 < 10 ? `0${date.getUTCMonth() + 1}` : date.getUTCMonth() + 1;
  return twoDigitMonth;
};

export const getTwoDigitMonthNonUTC = (date) => {
  const twoDigitMonth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  return twoDigitMonth;
};

export const getDateDate = (date) => {
  const day = date.substr(6, 2) >= 10 ? date.substr(6, 2) : date.substr(7, 1);
  return day;
};

export const getDateMonth = (date) => {
  const month = date.substr(4, 2) >= 10 ? date.substr(4, 2) - 1 : date.substr(5, 1) - 1;
  return month;
};

export const getDateYear = (date) => date.substr(0, 4);

// const dateString = "YYYYMMDD";
// Outputs: YYYY/MM/DD
export const getFormattedDate = (dateString) => {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  const formattedDate = `${year}/${month}/${day}`;

  return formattedDate;
};
